import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    circleThankUserCounts: PropTypes.array.isRequired,
    userAvatarUrls: PropTypes.object.isRequired,
  },
  render() {
    if (this.props.circleThankUserCounts.length == 0) {
      return <div />;
    }
    var list = this.props.circleThankUserCounts.map(function(item) {
      return (
        <div key={item.user_id} style={{ marginBottom: "4px" }}>
          <a href={"/member/profile/" + item.tunagate_id}>
            <img
              src={this.props.userAvatarUrls[item.user_id]}
              className="avatar-thumb"
              style={{ width: "25px", height: "25px" }}
            />
            <span>@{item.tunagate_id}</span>
          </a>
          <span style={{ marginLeft: "10px", color: "#e81c62" }}>
            <i className="fas fa-heart" /> {item.thanks_count}
          </span>
        </div>
      );
    }, this);
    return (
      <div
        style={{
          boxShadow: "0 0 2px #ccc",
          padding: "20px",
          marginBottom: "10px",
        }}
      >
        <p style={{ color: "#e81c62" }}>
          <strong>ありがとうリスト</strong>
        </p>
        {list}
      </div>
    );
  },
});
